import { Lock } from 'lucide-react'
import type { ReactNode } from 'react'

import type { OrgType } from '@/shared/domain'
import { Button } from '@/shared/ui/primitives'
import { EmptyState } from './empty-state'
import { PageTitleInline } from './page-title-inline'

type SubscriptionGateProps = {
  orgType: OrgType | null
  action: string
  onReactivate?: () => void
  onSwitchPersona?: () => void
}

function SubscriptionGate({ orgType, action, onReactivate, onSwitchPersona }: SubscriptionGateProps) {
  const orgNoun = orgType === 'outfitter' ? 'outfitter' : 'club'

  let description = `Your ${orgNoun}’s subscription is inactive.`
  let cta: ReactNode = null
  if (onReactivate) {
    description = `Your ${orgNoun}’s subscription is inactive. Reactivate it to ${action}.`
    cta = <Button onClick={onReactivate}>Reactivate subscription</Button>
  } else if (onSwitchPersona) {
    description = `Your ${orgNoun}’s subscription is inactive. Ask a manager to reactivate it, or switch to another persona.`
    cta = <Button onClick={onSwitchPersona}>Switch persona</Button>
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-hidden px-6 pb-6 pt-2 lg:p-6">
      <PageTitleInline />
      <EmptyState
        icon={Lock}
        heading="Subscription required"
        description={description}
        action={cta}
      />
    </div>
  )
}

export { SubscriptionGate }
export type { SubscriptionGateProps }
